export default "__VITE_ASSET__ce867af5__"